import {css} from '@emotion/css';
import { useNavigate } from '@solidjs/router';
import { backendTheme } from 'Shared/backend/Theme';
import { ThemeProvider } from 'Shared/ThemeProvider';
import { havePagePermission } from 'Shared/Page';
import {LoginBanner} from 'Shared/server/LoginBanner';
import { useSite, useUser } from 'Shared/SiteProvider';
import {AuthenticationForm, entryUrl, RegistrationForm, RegoEmailSent} from 'Shared/users/AuthenticationForm';
import { createSignal, Show, Switch, Match, onMount } from 'solid-js';
import { createStore } from 'solid-js/store';

export const loginStyle = () => css(backendTheme().root, {
	background: 'white',
	minHeight: '100vh',
	maxWidth: 450,
	margin: '0 auto',
	padding: '2em',
	paddingTop: '1em',

	'.vosLogo': {
		display: 'block',
		width: '5em',
		margin: '0 auto'
	}
});


export default function LoginPage()
{
	const site = useSite();
	const user = useUser();
	const navigate = useNavigate();

	const [regoEmail,setRegoEmail] = createSignal();
	const [themeStore,setTheme] = createStore(backendTheme());

	/* If logged in go to the /admin or /manager page */
	if (!user.isUnknown() && havePagePermission(user,site))
		navigate(entryUrl(site.type));

	onMount(() => document.body.style.opacity = '1');

	return (
		<ThemeProvider theme={themeStore} setTheme={setTheme}>
			<div class={loginStyle()}>
				<Switch>
					<Match when={!regoEmail()}>
						<LoginBanner />

						<AuthenticationForm />

						<Show when={useSite().type == 'artist'}>
							<RegistrationForm setRegoEmail={setRegoEmail} />
						</Show>
					</Match>
					<Match when={true}>
						<RegoEmailSent email={regoEmail()} />
					</Match>
				</Switch>
			</div>
		</ThemeProvider>
	);
}

